<template>
  <div>
    <slot
      v-if="error"
      :has-error="error"
    />
  </div>
</template>

<script>
import {
  EmitterClient,
  EmitterDelivery,
  MessageStatusExpired,
  MessageStatusFailed,
  TypeIncoming,
  TypeOutgoing
} from "../../../../services/chat/const";

export default {
  name:'ErrorMessageRoomComponents',
  props: {
    message: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      error: false,
    };
  },
  computed: {
    type() {
      if (this.message.emitter === EmitterClient) {
        return TypeIncoming;
      } else {
        return TypeOutgoing;
      }
    },
    isIncoming() {
      return this.type === TypeIncoming;
    },
  },
  watch: {
    error(e) {
      this.$emit('error', e);
    },
    message: {
      deep: true,
      handler() {
        this.errorRunCheck();
      },
    },
  },
  mounted() {
    this.errorRunCheck();
  },
  methods: {
    errorRunCheck() {
      this.error = this.errorCheck();
      if (!this.error) {
        setTimeout(() => this.error = this.errorCheck(), 11000);
      }
    },
    errorCheck() {
      if (this.isIncoming) return false;

      if (!this.message.is_sending && this.message.error) {
        return this.message.error;
      }

      if (
        this.message.emitter === EmitterDelivery &&
        [MessageStatusExpired, MessageStatusFailed].includes(this.message.status)
      ) {
        return '#11';
      }

      return false;
    },
  },
}
</script>

<style scoped>

</style>
